import { render, staticRenderFns } from "./AddVisitRecord.vue?vue&type=template&id=21adc6e6&scoped=true"
import script from "./AddVisitRecord.vue?vue&type=script&lang=js"
export * from "./AddVisitRecord.vue?vue&type=script&lang=js"
import style0 from "./AddVisitRecord.vue?vue&type=style&index=0&id=21adc6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21adc6e6",
  null
  
)

export default component.exports